export const CommonMessages = {
    // Error
    recoveryEmailError: 'Please insert valid secondary email address format.',
    emailError: 'Please insert valid email address format.',
    passwordMatchError: 'Password and confirm password both should match!',
    schoolNameMatchError: 'Please select Appropriate School Name!',
    // userDetailMatchError: 'You are currently not in our system. Please contact your principal to help activate the account. We will also follow up with your school to assist.',
    // 'Your First Name and Last Name does not match with your Student Id. Please check your information or contact your counselor',
    // userAlreadyExistError: 'Already your account has been established. Please login.',
    userAlreadyRegistered: 'User Already Registered !!',
    noDataFound: 'No data found!!',

    // Success
    userDetailMatchSuccess: 'Go to Next', // on student register next click
    studentRegSuccess: 'Student Registered Successfully', // student account create
    // ParentRegSuccess: 'Parent Registered Successfully', // parent account create

    // Academics, Athletics, Activity, Interest
    curriculumSaved: 'Curriculum Saved',
    interestSaved: 'Interests Saved',
    academicSaved: 'Academics Saved',
    activitySaved: 'Activities Saved',
    athleticsSaved: 'Athletics Saved',
    ladderSaved: 'College Checklist Saved',  // college checklist


}

// Spanish translations for toast/messages
export const CommonMessagesEs = {
    // Error
    recoveryEmailError: 'Por favor, introduzca un formato de dirección de correo electrónico secundaria válido.',
    emailError: 'Por favor, introduzca un formato de correo electrónico válido.',
    passwordMatchError: '¡La contraseña y la confirmación deben coincidir!',
    schoolNameMatchError: '¡Seleccione el nombre de la escuela correcto!',
    userAlreadyRegistered: '¡Usuario ya registrado!',
    noDataFound: '¡No se encontraron datos!',

    // Success
    userDetailMatchSuccess: 'Ir a siguiente',
    studentRegSuccess: 'Estudiante registrado correctamente',

    // Academics, Athletics, Activity, Interest
    curriculumSaved: 'Plan de estudios guardado.',
    interestSaved: 'Intereses Guardados.',
    academicSaved: 'Académicos Guardados.',
    activitySaved: 'Actividades Guardadas.',
    athleticsSaved: 'Atletismo Guardado.',
    ladderSaved: 'Lista de verificación universitaria guardada.',
};

// Helper to get message by key using current language
export const getCommonMessage = (key, lang = 'en') => {
    const en = CommonMessages[key];
    const es = CommonMessagesEs[key];
    if (lang === 'es' && es) return es;
    return en;
};